const initialState = {
isLoading: true,
settlementdata:[],
franchise_id:"",
franchise_name:""
}
export default initialState;